import { useQuery } from 'hooks/useQuery'

import { fetchPendingMembershipsByUserId } from 'utils/queries'

import { PendingMembership } from 'types/pendingMemberships'

/**
 * Gets pending memberships by user ID.
 * @param userId The user ID to fetch pending memberships for.
 * @returns A PendingMembership, which is an array of programs.
 */
export const usePendingMemberships = ({ userId }: { userId?: string }) => {
  return useQuery<Array<PendingMembership> | null>(['pendingMemberships', userId], () =>
    fetchPendingMembershipsByUserId(userId),
  )
}
